import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactGA from 'react-ga4';
import { useTranslation } from 'react-i18next';

import FormContainer from 'components/UI/FormContainer/FormContainer';
import RecoverAccountFirstStep from 'components/RecoverAccount/FirstStep/RecoverAccountFirstStep';
import RecoverAccountSecondStep from 'components/RecoverAccount/SecondStep/RecoverAccountSecondStep';
import RecoverAccountThirdStep from 'components/RecoverAccount/ThirdStep/RecoverAccountThirdStep';
import RecoverAccountFourthStep from 'components/RecoverAccount/FourthStep/RecoverAccountFourthStep';
import ErrorMessage from 'components/UI/ErrorMessage/ErrorMessage';

import { academyDataActions } from 'store/academy-slice';

import classes from './RecoverAccount.module.css';

const RecoverAccount = () => {
  const { t } = useTranslation(['recoverAccount']);
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState(false);
  const [message, setMessage] = useState(false);
  const [typeAlias, setTypeAlias] = useState(0);
  const [alias, setAlias] = useState(0);
  const [step, setStep] = useState(1);
  const [token, setToken] = useState(0);
  const [title, setTitle] = useState(t('title_recover'));
  const [subtitle, setSubtitle] = useState(t('how_recover_account'));
  const dataAcademy = useSelector(state => state.academyInfo);
  const dataUser = useSelector(state => state.userInfo);
  const recoverAccountData = useSelector(
    state => state.recoverAccountInfo
  );

  useEffect(() => {
    ReactGA.initialize(
      [
        {
          trackingId: 'G-5883QCZJX8',
          gaOptions: {
            name: 'trackerMayahii'
          }
        },
        {
          trackingId: `${dataAcademy.data.analitycs}`,
          gaOptions: { name: 'trackerUser' }
        }
      ],
      { debug: false }
    );

    ReactGA.send({
      hitType: 'pageview',
      page: `/${dataAcademy.data.shortName}/recoverAccount`,
      title: `/${dataAcademy.data.shortName}/recoverAccount`
    });
  }, [dataAcademy]);

  useEffect(() => {
    if (dataUser.data.usuario) {
      window.location.href = `/${dataAcademy.data.shortName}`;
    }
  }, [dataUser.data]);

  useEffect(() => {
    if (recoverAccountData.alias.length > 0) {
      if (recoverAccountData.alias[0] === 'noUser') {
        setErrorMessage(true);
        setMessage('noUser');
      } else if (
        recoverAccountData.alias[0].length > 0 &&
        step === 1
      ) {
        setStep(2);
        setTitle(t('how_recover_account'));
        setSubtitle(t('choose_the_option'));
      }
    }
  }, [recoverAccountData]);

  useEffect(() => {
    if (recoverAccountData.sendCode) {
      const typeAliasText =
        typeAlias === '1' ? t('email') : t('phone');
      const message = `{t('sent_code')} ${typeAliasText} ${alias} {t('mayahii_account')} ${typeAliasText} {t('enter_code')}`;
      setStep(3);
      setTitle(t('validate_identity'));
      setSubtitle(message);
    }
  }, [recoverAccountData.sendCode]);

  useEffect(() => {
    if (recoverAccountData.checkToken[0] === 'noToken') {
      setErrorMessage(true);
      setMessage('noToken');
    } else if (recoverAccountData.checkToken[0]) {
      setStep(4);
      setTitle(t('create_password'));
      setSubtitle(t('password_characters'));
    }
  }, [recoverAccountData.checkToken]);

  useEffect(() => {
    dispatch(
      academyDataActions.showBanner({
        showBanner: true
      })
    );
  }, []);

  const setTypeAliasHandler = type => {
    setTypeAlias(type);
  };

  const setAliasHandler = alias => {
    setAlias(alias);
  };

  const setTokenHandler = token => {
    setToken(token);
  };

  const changeErrorMessageHandler = () => {
    setErrorMessage(false);
  };

  return (
    <FormContainer
      title={
        step === 1
          ? t('title_recover')
          : step === 2
          ? t('how_recover_account')
          : step === 3
          ? t('validate_identity')
          : step === 4
          ? t('create_password')
          : title
      }
      subtitle={
        step === 1
          ? t('how_recover_account')
          : step === 2
          ? t('choose_the_option')
          : step === 3
          ? `${t('sent_code')} ${
              typeAlias === '1' ? t('email') : t('phone')
            } ${alias} ${t('mayahii_account')} ${
              typeAlias === '1' ? t('email') : t('phone')
            } ${t('enter_code')}`
          : step === 4
          ? t('password_characters')
          : subtitle
      }
    >
      <div className={classes.recoverAccountContainer}>
        {step === 1 && (
          <RecoverAccountFirstStep
            setTypeAlias={setTypeAliasHandler}
            changeErrorMessage={changeErrorMessageHandler}
          />
        )}
        {step === 2 && (
          <RecoverAccountSecondStep
            data={recoverAccountData.alias[0]}
            setAlias={setAliasHandler}
          />
        )}
        {step === 3 && (
          <RecoverAccountThirdStep
            alias={alias}
            tokenHandler={setTokenHandler}
            changeErrorMessage={changeErrorMessageHandler}
          />
        )}
        {step === 4 && (
          <RecoverAccountFourthStep token={token} alias={alias} />
        )}
      </div>
      {errorMessage && (
        <ErrorMessage
          open={errorMessage}
          message={
            message === 'noUser'
              ? t('no_user')
              : message === 'noToken'
              ? t('incorrect_code')
              : ''
          }
        />
      )}
    </FormContainer>
  );
};

export default RecoverAccount;
